import { useEffect, useState } from "react"
import { useSelector } from "react-redux"

import MajorMedItem from "./MajorMedItem"
import MajorMedNoItems from "./MajorMedNoItems"

import classes from '../Shared/Container.module.css'

const MajorMedDetails =() => {
    const activeCase = useSelector(state => state.case.activeCase) 

    const [data, setData] = useState(null)

    useEffect(() => {
        if (activeCase) {
            let arr = [...activeCase.major_meds].sort(function(x, y) {
                return ((x.active == y.active) ? 0 : x.active ? -1 : 1);
            });

            // sort by biiling 
            let arr2 = arr.sort(function(x, y) {
                return ((x.billing_order == y.billing_order) ? 0 :( x.billing_order < y.billing_order || !x.billing_order || !y.billing_order) ? -1 : 1)
            });

            //final sort by primary
            let arr3 = arr2.sort(function(x, y) {
                return ((x.is_primary_insurance == y.is_primary_insurance) ? 0 : x.is_primary_insurance ? -1 : 1)
            });
    
            setData(arr3)
        }
    }, [activeCase])

    return <div className={classes.container}>
        <MajorMedNoItems permissionType={'case_major_med'} />

        {data && data.map(item => (
            <MajorMedItem key={item.id} data={item} apiCase={'case_major_med'}/>
        ))}
    </div>
}

export default MajorMedDetails